import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import DynamicForm from "../../../components/DynamicForm";
import {
  sponsorMasterUserFields,
  sponsorMasterUserValidationSchema,
} from "../../../Schema/SponsorMasterUserSchema";
import { useAddSponsorMasterUser } from "../../../custom-hooks/queries";
import NotificationModal from "../../../components/NotificationModal";

const AddSponsorMasterUser = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");

  const { mutate: addUser, isError } = useAddSponsorMasterUser();

  const onSubmit = (data) => {
    const userData = {
      ...data,
      sponsor_id: uuidv4(),
    };

    addUser(userData, {
      onSuccess: () => {
        setMessage("Sponsor Master User created successfully");
        setShow(true);
        setTimeout(() => navigate("/Backend/Users/SponsorMasterUsers"), 2000);
      },
      onError: (error) => {
        setMessage(error.response?.data?.message || "Failed to create user");
        setShow(true);
      },
    });
  };

  return (
    <>
      <DynamicForm
        formTitle="Add New Sponsor Master User"
        formDescription="Complete the information below to create a new Sponsor Master User."
        fields={sponsorMasterUserFields.filter(
          (field) => field.name !== "sponsor_id"
        )}
        validationSchema={sponsorMasterUserValidationSchema}
        onSubmit={onSubmit}
      />
      <NotificationModal
        open={show}
        setOpen={setShow}
        desc={message}
        title={isError ? "Error" : "Success"}
        error={isError}
      />
    </>
  );
};

export default AddSponsorMasterUser;
